<template>
  <v-container>
    <h1>Providers</h1>
    <hr />

    <p class="subtle">
      The providers page is currently being hidden from users. As an admin you can still access it.
    </p>
    <router-link
      class="default-btn link providers-link"
      :to="{ name: 'ProvidersList' }"
      target="_blank"
    >
      Go to frontend providers page
    </router-link>

    <ProviderDescriptions />
    <ProvidersList />
  </v-container>
</template>

<script>
import ProviderDescriptions from './ProviderDescriptions'
import ProvidersList from './ProvidersList'

export default {
  name: 'AdminProviders',
  components: {
    ProviderDescriptions,
    ProvidersList,
  },
}
</script>

<style lang="scss" scoped>
p.subtle {
  margin: 0;
}

.providers-link {
  display: inline-flex !important;
  margin: 0 0 20px !important;
}
</style>
